var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "wow-travel-info-ajax-a__item" }, [
      _c(
        "div",
        {
          staticClass:
            "wow-travel-info-ajax-a__media uk-card-media-top uk-cover-container"
        },
        [
          _c("a", { attrs: { href: _vm.url, title: _vm.title } }, [
            _c("canvas", { attrs: { width: "400", height: "300" } }),
            _vm._v(" "),
            _c("img", {
              attrs: { src: _vm.imageUrl, alt: _vm.title, "uk-cover": "" }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "uk-padding-small" }, [
        _c("h4", { staticClass: "uk-margin-remove-bottom" }, [
          _c(
            "a",
            {
              staticClass: "wow-travel-info-ajax-a__title",
              attrs: { href: _vm.url, title: _vm.title }
            },
            [_vm._v(_vm._s(_vm.title))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "meta uk-margin-small-top" }, [
          _vm.postDate
            ? _c(
                "span",
                {
                  staticClass:
                    "wow-travel-info-ajax-a__date date uk-text-primary"
                },
                [_vm._v(_vm._s(_vm.postDateString))]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("hr", {
          staticClass: "wow-travel-info-ajax-a__line-section uk-margin-small"
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "wow-travel-info-ajax-a__detail detail uk-margin-small-top"
          },
          [_vm._v("\n        " + _vm._s(_vm.postDetail) + "\n      ")]
        ),
        _vm._v(" "),
        _c("div", [
          _c(
            "a",
            {
              staticClass:
                "wow-travel-info-ajax-a__link uk-button uk-button-primary",
              attrs: { href: _vm.url }
            },
            [_vm._v("อ่านต่อ")]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }